import { TextArea as GammaTextArea } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type TextAreaProps = React.ComponentProps<typeof GammaTextArea>

type Props = Omit<TextAreaProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
  extra?: React.ComponentProps<typeof GammaTextArea>['extra']
}

const TextArea = ({ missingLabel, extra, ...props }: Props) => (
  <GammaTextArea
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    extra={extra}
  />
)

export default TextArea
